import { config } from '../../config/Constants';
import Axios from 'axios';

export const clickupAPI = async (data) => {
  try {
    const response = await Axios.get(config.url.CLICKUP_SERVICE, {
      params: data
    });
    return response.data; 
  } catch (error) {
      console.log(error);
      return [];
  }
}